var Backbone = require('backbone');


var MedProfileModel = Backbone.Model.extend({

    urlRoot: '/api/medprofile',

    defaults: {
        id: undefined,
        name: undefined,
        object: {
            personId: undefined,
            medications: []
        }
    },

    sync: function (method, model, options) {
        model.attributes.object.medications = model.attributes.object.medications.map(function (medication) {
            medication = _.omit(medication, 'id');
            return medication;
        });
        options.attrs = model.attributes;

        return Backbone.sync.call(this, method, model, options);
    }

});


module.exports = MedProfileModel;


//////////////////
// WEBPACK FOOTER
// ./app/models/med-profile-model.js
// module id = 213
// module chunks = 0